export const Plus = ({ className }: { className: string }) => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 25 26'
      fill='none'
    >
      <path
        d='M12.9509 12.3623H25V13.6623H12.9509V26H11.5731V13.6623H0V12.3623H11.5731V0H12.9509V12.3623Z'
        fill='black'
      />
    </svg>
  );
};
